/**
 * حارس أسماء الشرايح — **اسم معروض واحد لحاجة واحدة**.
 *
 * 🔴 البلاغ اللي وَلَد الملف ده: شاشة الليدز وشاشة الإشراف الإداري كانوا
 *    بيعرضوا شيب بنفس النص بالحرف («محتاج متابعة») لمعنيين مختلفين تمامًا —
 *    طلب لسه في مرحلة المكالمات ⇄ توقف موعد متابعته عدّى. مشرفة قرأت فقرة
 *    الدليل عن واحدة وفضلت تدوّر عليها في التانية.
 *
 * ⚠️ مساحة الأسماء أزحم مما تبدو: «محتاج استكمال» مستعملة في الطلاب
 *    والمعلمين (**بنفس المعنى** — جودة داتا)، و«نشط» فيهم الاتنين (نفس
 *    الحالة، والعنوان بيقول على مين)، و«الكل» في كل شاشة. التلاتة دول
 *    تناظر مش لبس، فبيتستثنوا صراحةً.
 *
 * 🔑 الحارس بيصرخ **ساعة** التصادم مش بعد ما موظفة تبلّغ — نفس نمط
 *    `orphanNavPaths` في `nav-items.ts` اللي شغّال وناجح في الريبو.
 *
 * ⛔ **لازم يتستورد من موديول بيتحمّل فعلًا.** موديول محدش مستورده ما
 *    بيشتغلش أبدًا وإحنا فاكرين إن عندنا حماية — نفس عيلة «مكتوبٌ صحيحًا
 *    وبلا طريقٍ للشاشة». عشان كده `nav-items.ts` (اللي `Shell` بيستورده في
 *    كل شاشة) هو اللي بيستورد الملف ده.
 */
import { LEAD_SEGMENTS } from "@/api/leads";
import { LEAVE_SEGMENTS } from "@/api/supervision";
import { STUDENT_SEGMENTS, TEACHER_SEGMENTS } from "@/api/registry";

/** أسماء معناها واحد في كل الشاشات — تكرارها تناظر مقصود مش تصادم */
const SAME_MEANING_EVERYWHERE = new Set(["الكل", "محتاج استكمال", "نشط"]);

const CATALOGS: { what: string; chips: readonly string[] }[] = [
  { what: "طلبات التسجيل", chips: LEAD_SEGMENTS.map((s) => s.chip) },
  { what: "التوقفات", chips: LEAVE_SEGMENTS.map((s) => s.chip) },
  { what: "سجل الطلاب", chips: STUDENT_SEGMENTS.map((s) => s.chip) },
  { what: "سجل المعلمين", chips: TEACHER_SEGMENTS.map((s) => s.chip) },
];

const firstSeenIn = new Map<string, string>();
const clashes: string[] = [];

for (const { what, chips } of CATALOGS) {
  for (const chip of chips) {
    if (SAME_MEANING_EVERYWHERE.has(chip)) continue;
    const seen = firstSeenIn.get(chip);
    if (seen !== undefined && seen !== what) {
      clashes.push(`«${chip}» في «${seen}» و«${what}»`);
    } else {
      firstSeenIn.set(chip, what);
    }
  }
}

if (clashes.length > 0) {
  console.error(
    `[chips] اسم شريحة واحد لحاجتين مختلفتين: ${clashes.join(" · ")} —` +
      " الموظفة هتقرا الدليل عن واحدة وتدوّر عليها في التانية.",
  );
}

/** بيتصدّر عشان الاستيراد ما يتشالش كـside-effect بلا استعمال */
export const CHIP_NAME_CLASHES: readonly string[] = clashes;
